import { FProgressBar } from '../../../components/base';
import TreatmentPlanV3 from '../../treatmentPlanV3';
import TreatmentPlanLegacy from './TreatmentPlanLegacy';
import TreatmentPlanVersionError from './TreatmentPlanVersionError';
import { useTreatmentPlanVersion } from '../hooks';

export default function TreatmentPlanVersionGate() {
  const { isTreatmentPlanV3, isResolvingVersion, hasVersionError, retryVersionResolution } =
    useTreatmentPlanVersion();

  if (isResolvingVersion) return <FProgressBar />;
  if (hasVersionError) return <TreatmentPlanVersionError onRetry={retryVersionResolution} />;

  return isTreatmentPlanV3 ? <TreatmentPlanV3 /> : <TreatmentPlanLegacy />;
}
